<h2 mat-dialog-title>{{title}}</h2>
@let accounts_ds = accountsDataSource;
@let classes_ds = classesDataSource;
@let departments_ds = departmentsDataSource;
<mat-dialog-content>
  @if (busyLoadingAccounts) {
    <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
  }
  <mat-tab-group class="w-100" [style.height.px]="600" (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Accounts" class="w-100">
      @if(accounts_ds){
        <table mat-table [dataSource]="accounts_ds ?? []" matSort #accountsSortRef="matSort" (matSortChange)="accountSortChange($event)">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Name</b> &nbsp; (with@if (!indentAccountName) {
            <span>out</span>
          }&nbsp;hierarchy)</th>
          <td mat-cell *matCellDef="let account" [appHighlight]="[accountsFilterValue,account.name]" [style.paddingLeft.rem]="indentAccountName?account.hierarchyLevel+1:1">{{account.name}}</td>
        </ng-container>
        <ng-container matColumnDef="acctNum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Account Number</b></th>
          <td mat-cell *matCellDef="let account" [appHighlight]="[accountsFilterValue,account.acctNum]">{{account.acctNum}}</td>
        </ng-container>
        <ng-container matColumnDef="fqn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Fully Qualified Name</b></th>
          <td mat-cell *matCellDef="let account" [appHighlight]="[accountsFilterValue,account.fullyQualifiedName]">{{account.fullyQualifiedName}}</td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Type</b></th>
          <td mat-cell *matCellDef="let account" [appHighlight]="[accountsFilterValue,account.accountType]">{{account.accountType}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedAccountColumns"></tr>
        <tr mat-row *matRowDef="let account; columns: displayedAccountColumns;"></tr>
      </table>
    }
    <mat-divider class="w-100"></mat-divider>
  </mat-tab>
  <mat-tab label="Classes">
    @if (busyLoadingClasses) {
      <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
    }
    @if (classes_ds?.data!.length) {
      <table mat-table [dataSource]="classes_ds!" matSort #classesSortRef="matSort" (matSortChange)="classSortChange($event)" class="w-100">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Name</b> &nbsp; (with@if (!indentClassName) {
          <span>out</span>
        }&nbsp;hierarchy)</th>
        <td mat-cell *matCellDef="let class" [appHighlight]="[classesFilterValue,class.name]" [style.paddingLeft.rem]="indentClassName?class.hierarchyLevel+1:1">{{class.name}}</td>
        </ng-container>
        <ng-container matColumnDef="fqn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Fully Qualified Name</b></th>
          <td mat-cell *matCellDef="let class" [appHighlight]="[classesFilterValue,class.fullyQualifiedName]">{{class.fullyQualifiedName}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedClassColumns"></tr>
        <tr mat-row *matRowDef="let class; columns: displayedClassColumns;"></tr>
      </table>
      <mat-divider class="w-100"></mat-divider>
  }
  @if (!classes_ds?.data?.length) {
    <div class="flex-col justify-stretch items-center"><span class="mt-5">No classes exist in QBO</span></div>
  }
</mat-tab>
<mat-tab label="Departments">
  @if (busyLoadingDepartments) {
    <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
  }
  @if (departments_ds?.data?.length) {
    <table mat-table [dataSource]="departments_ds!" matSort #departmentsSortRef="matSort" (matSortChange)="departmentSortChange($event)" class="w-100">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Name</b> &nbsp; (with@if (!indentDepartmentName) {
        <span>out</span>
      }&nbsp;hierarchy)</th>
      <td mat-cell *matCellDef="let department" [appHighlight]="[departmentsFilterValue,department.name]" [style.paddingLeft.rem]="indentDepartmentName?department.hierarchyLevel+1:1">{{department.name}}</td>
    </ng-container>
    <ng-container matColumnDef="fqn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Fully Qualified Name</b></th>
      <td mat-cell *matCellDef="let department" [appHighlight]="[departmentsFilterValue,department.fullyQualifiedName]">{{department.fullyQualifiedName}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedDepartmentColumns"></tr>
    <tr mat-row *matRowDef="let department; columns: displayedDepartmentColumns;"></tr>
  </table>
  <mat-divider class="w-100"></mat-divider>
}
@if (!departments_ds?.data?.length) {
  <div class="flex-col justify-stretch items-center"><span class="mt-5">No departments exist in QBO</span></div>
}
</mat-tab>
</mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="w-100 flex-row space-between items-center mt-3 mx-3">
    @if (currentTabIndex==0 && accounts_ds?.data && accounts_ds!.data.length>0) {
      <mat-form-field appearance="fill">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyAccountsFilter($event)" placeholder="Search Columns" [value]="accountsFilterValue" />
      </mat-form-field>
    }
    @if (currentTabIndex==1 && classes_ds?.data?.length) {
      <mat-form-field appearance="fill">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyClassesFilter($event)" placeholder="Search Columns" [value]="classesFilterValue"/>
      </mat-form-field>
    }
    @if (currentTabIndex==2 && departments_ds?.data?.length) {
      <mat-form-field appearance="fill">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyDepartmentsFilter($event)" placeholder="Search Columns" [value]="departmentsFilterValue" />
      </mat-form-field>
    }
    <a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()" tabindex="-1"><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>
